var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.42188,
    y: 1,
    width: 15.1546,
    height: 15.1546,
    rx: 7.57729,
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00062 4.46533C9.22317 4.46533 9.40358 4.64574 9.40358 4.86829L9.40358 6.48014C9.40358 6.70269 9.22317 6.8831 9.00062 6.8831C8.77807 6.8831 8.59766 6.70269 8.59766 6.48014L8.59766 4.86829C8.59766 4.64574 8.77807 4.46533 9.00062 4.46533Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00062 10.9126C9.22317 10.9126 9.40358 11.093 9.40358 11.3156L9.40358 12.9274C9.40358 13.15 9.22317 13.3304 9.00062 13.3304C8.77807 13.3304 8.59766 13.15 8.59766 12.9274L8.59766 11.3156C8.59766 11.093 8.77807 10.9126 9.00062 10.9126Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86607 5.76402C6.02344 5.60665 6.27858 5.60665 6.43594 5.76402L7.57633 6.9044C7.73369 7.06177 7.73369 7.31691 7.57633 7.47427C7.41896 7.63164 7.16382 7.63164 7.00645 7.47427L5.86607 6.33389C5.70871 6.17653 5.70871 5.92139 5.86607 5.76402Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4227 10.3216C10.5801 10.1643 10.8352 10.1643 10.9926 10.3216L12.133 11.462C12.2903 11.6194 12.2903 11.8745 12.133 12.0319C11.9756 12.1893 11.7205 12.1893 11.5631 12.0319L10.4227 10.8915C10.2653 10.7341 10.2653 10.479 10.4227 10.3216Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56641 8.89808C4.56641 8.67553 4.74682 8.49512 4.96937 8.49512L6.58121 8.49512C6.80376 8.49512 6.98417 8.67553 6.98417 8.89808C6.98417 9.12063 6.80376 9.30104 6.58121 9.30104L4.96937 9.30104C4.74682 9.30104 4.56641 9.12063 4.56641 8.89808Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0137 8.89808C11.0137 8.67553 11.1941 8.49512 11.4166 8.49512L13.0285 8.49512C13.251 8.49512 13.4314 8.67553 13.4314 8.89808C13.4314 9.12063 13.251 9.30104 13.0285 9.30104L11.4166 9.30104C11.1941 9.30104 11.0137 9.12063 11.0137 8.89808Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57633 10.3216C7.73369 10.479 7.73369 10.7341 7.57633 10.8915L6.43594 12.0319C6.27858 12.1893 6.02344 12.1893 5.86607 12.0319C5.70871 11.8745 5.70871 11.6194 5.86607 11.462L7.00645 10.3216C7.16382 10.1643 7.41896 10.1643 7.57633 10.3216Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.133 5.76402C12.2903 5.92139 12.2903 6.17653 12.133 6.33389L10.9926 7.47427C10.8352 7.63164 10.5801 7.63164 10.4227 7.47427C10.2653 7.31691 10.2653 7.06177 10.4227 6.9044L11.5631 5.76402C11.7205 5.60665 11.9756 5.60665 12.133 5.76402Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHere);
export default __webpack_public_path__ + "static/media/here.52cd72116f29ec213f808cd97acb2b93.svg";
export { ForwardRef as ReactComponent };